import { Map, Record } from "immutable";

import { CrudBuilderState } from "seneca-common/utils/apiStates";

import { Memories } from "./state/memories/Memories";
import Memory from "./state/memories/memory/Memory";
import memoriesMetaInitialState from "./state/meta";

export type MemoriesStateSliceType = {
  memories: Memories;
  meta: CrudBuilderState | Map<any, any>;
};

export type OptionalMemoriesStateSliceType = Partial<MemoriesStateSliceType>;

const defaultMemoriesStateSlice: MemoriesStateSliceType = {
  memories: Map<string, Memory>(),
  meta: memoriesMetaInitialState
};

export default class MemoriesStateSlice extends Record(
  defaultMemoriesStateSlice
) {}
